import React, { useEffect } from 'react';

const ContactSection = () => {
  useEffect(() => {
    const form = document.getElementById('contact-form');
    if (!form) return;

    const handleSubmit = async (event) => {
      event.preventDefault();

      const formData = new FormData(form);
      const loading = form.querySelector('.loading');
      const sentMessage = form.querySelector('.sent-message');
      const errorMessage = form.querySelector('.error-message');

      loading.style.display = 'block';
      sentMessage.style.display = 'none';
      errorMessage.style.display = 'none';

      try {
        const response = await fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          body: formData
        });

        const data = await response.json();
        loading.style.display = 'none';

        if (data.success) {
          sentMessage.style.display = 'block';
          form.reset();
        } else {
          errorMessage.textContent = data.message || 'An error occurred. Please try again.';
          errorMessage.style.display = 'block';
        }
      } catch (error) {
        loading.style.display = 'none';
        errorMessage.textContent = 'An error occurred while sending your message. Please try again later.';
        errorMessage.style.display = 'block';
      }
    };

    form.addEventListener('submit', handleSubmit);

    return () => {
      form.removeEventListener('submit', handleSubmit);
    };
  }, []);

  return (
    <div id="contact" className="paddsection">
      <div className="container">
        <div className="contact-block1">
          <div className="row">
            <div className="col-lg-6">
              <div className="contact-contact">
                <h2 className="mb-30">Let's Connect</h2>
                <ul className="contact-details">
                  <li><span>Toronto, Canada</span></li>
                  <li><span>Phone: +1 4379551406</span></li>
                  <li><span>Email: jamesiukalu@gmail.com</span></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <form id="contact-form" className="php-email-form">
                <input type="hidden" name="access_key" value="511349d5-004d-46bf-84c5-7528504f0df4" />
                <input type="hidden" name="subject" value="New Contact Form Submission from Portfolio" />
                <input type="hidden" name="from_name" value="Portfolio Contact Form" />
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" required />
                  </div>
                  <div className="col-md-6 mb-3">
                    <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" required />
                  </div>
                </div>
                <div className="mb-3">
                  <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" required />
                </div>
                <div className="mb-3">
                  <textarea className="form-control" name="message" rows="5" placeholder="Message" required></textarea>
                </div>
                <div className="mb-3">
                  <div className="loading">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message">Your message has been sent. Thank you!</div>
                </div>
                <div className="text-center"><input type="submit" className="btn btn-default btn-send" value="Send message" /></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
